import api from '../config/api';

const systemService = {
  async getExchangeRate() {
    const response = await api.get('/api/system/exchange-rate');
    return response.data;
  },

  async updateExchangeRate(sypPerUsd) {
    const response = await api.put('/api/system/exchange-rate', { sypPerUsd });
    return response.data;
  },
};

export default systemService;
